import { useEffect, useState } from "react";
import { getLiveStatus, subscribeLiveStatus } from "./liveSocket";

/** Live-update connection state: "off" | "connecting" | "live" | "reconnecting". */
export default function useLiveStatus() {
  const [status, setStatus] = useState(getLiveStatus);
  useEffect(() => subscribeLiveStatus(setStatus), []);
  return status;
}
